import * as React from 'react';
import { Backdrop, CircularProgress, BackdropProps as MuiBackdropProps } from '@material-ui/core';
import { Theme, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  backdropContainer: {
    position: 'relative',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100%',
    minHeight: '100%',
    minWidth: '100%',
    width: '100%',
  },
  root: {
    position: 'absolute',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    zIndex: 1,
  },
}));

export interface LoadingContainerProps
  extends Pick<MuiBackdropProps, Exclude<keyof MuiBackdropProps, 'open'>> {
  showChildrenWhileLoading?: boolean;
  loading: boolean;
}

/**
 * Use `LoadingContainer` when you want to either show a loading spinner over an area and prevent the component children from rendering, or to show the children with an overlay with the spinner to indicate loading or a transition state.
 * The parent element of Loading Container must be position: relative
 *
 * ```js
 * import { LoadingContainer } from 'ui';
 * ```
 */
const LoadingContainer: React.FunctionComponent<LoadingContainerProps> = ({
  children,
  showChildrenWhileLoading = false,
  loading,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <div className={classes.backdropContainer}>
      <Backdrop
        classes={{
          root: classes.root,
        }}
        open={loading}
        {...rest}
      >
        {loading && <CircularProgress />}
      </Backdrop>
      {showChildrenWhileLoading ? children : loading ? null : children}
    </div>
  );
};
export default LoadingContainer;
